/**
 * Addresses for files that ship beside the app (the logo, the OpenAPI document).
 *
 * The app does not always live at the root of its domain. When it is served under a path -
 * `portal-qa.tabservice.net/efile/` rather than a domain of its own - a `src="/brand/..."`
 * written by hand would ask the portal for that file and get the portal's own not-found page.
 *
 * Vite rewrites the addresses it can see for itself: imported modules, CSS `url()`, and the
 * ones in index.html. It cannot rewrite a string in a component, so those go through here.
 * `import.meta.env.BASE_URL` is whatever the build was given, always with a trailing slash.
 */
export function assetUrl(path: string): string {
  return `${import.meta.env.BASE_URL}${path.replace(/^\/+/, '')}`;
}

/** The Tab Service mark, used on every screen that has no application shell around it. */
export const LOGO_URL = assetUrl('brand/tab-service-logo.svg');
